<template>
  <div class="dashboard__export__data">
    <div class="dropdown" @click="toggleOptions">
      Export
    </div>
    <div class="options" v-if="showOptions">
      <div class="csv">
        <download-csv :data="csvData">
          CSV
        </download-csv>
      </div>
    </div>
  </div>
</template>

<script>
import downloadCsv from "vue-json-csv";
export default {
  props: {
    csvData: {
      type: Array,
      default: []
    },
    showOptions: {
      type: Boolean
    }
  },
  components: {
    downloadCsv
  },
  methods: {
    toggleOptions() {
      this.$emit("toggleoptions", true);
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/resuables/export-data.vue